import { useMemo } from "react"

export const toTitleCase = (string) => {
  var alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/

  return string
    .split(" ")
    .map(function (current, index, array) {
      return current.replace(alphanumericPattern, function (match) {
        return match.toUpperCase()
      })
    })
    .join(" ")
}

export const localizeDate = (dt) =>
  dt.toDate().toLocaleDateString("it-IT", { timeZone: "Europe/Rome" })

export const localizeDateWithDay = (dt) =>
  toTitleCase(
    dt.toDate().toLocaleDateString("it-IT", {
      timeZone: "Europe/Rome",
      weekday: "short",
      year: "numeric",
      month: "long",
      day: "numeric",
    })
  )

export const localizeDateTime = (dt) =>
  [
    dt.toDate().toLocaleDateString("it-IT", { timeZone: "Europe/Rome" }),
    dt.toDate().toLocaleTimeString("it-IT", { timeStyle: "short" }),
  ].join(" ")

export const useLines = (order, categories) =>
  useMemo(
    () =>
      order
        ? Object.values(order.cart).filter((line) =>
            categories.includes(line.category)
          )
        : [],
    [order, categories]
  )

export const getToday = () => {
  var output = new Date()
  output.setHours(0, 0, 0, 0)
  return output
}
